export const windowStyles = [
  {
    id: "casement",
    name: "Casement Windows",
    category: "popular",
    tagline: "The UK's most popular window style",
    desc: "Hinged on the side and opening outward, casement windows provide excellent ventilation and are available in virtually any size. Ideal for almost every room in the home.",
    features: ["Side-hung or top-hung", "Tilt-for-cleaning option", "Multi-point locking", "Available uPVC & aluminium"],
    upvc: true,
    aluminium: true,
    image: "https://public.readdy.ai/ai/img_res/5e8212e9fc1a8b71a5943cb9c59af137.jpg",
    from: "£280",
    popularFor: "Bedrooms, living rooms, kitchens",
  },
  {
    id: "tilt-turn",
    name: "Tilt & Turn",
    category: "popular",
    tagline: "Maximum ventilation and easy cleaning",
    desc: "Tilt inward for secure ventilation, or turn fully open for easy access and cleaning. The most versatile window style for modern homes, especially upper floors.",
    features: ["Dual opening modes", "Child-safe tilt position", "Easy interior cleaning", "European engineered"],
    upvc: true,
    aluminium: true,
    image: "https://readdy.ai/api/search-image?query=tilt%20and%20turn%20window%20modern%20upvc%20aluminium%20frame%20open%20interior%20contemporary%20uk%20home%20bright%20clean%20natural%20light%20living%20room&width=600&height=400&seq=win-tiltturn&orientation=landscape",
    from: "£320",
    popularFor: "Apartments, upper floors, kitchens",
  },
  {
    id: "vertical-slider",
    name: "Vertical Sliding Sash",
    category: "popular",
    tagline: "Period character with modern performance",
    desc: "Authentic sliding sash appearance with the thermal and security performance of modern materials. Perfect for Victorian and Edwardian homes across Surrey without sacrificing efficiency.",
    features: ["Authentic run-through horns", "Brushed chrome hardware", "Spring-balanced operation", "Draught-sealed sashes"],
    upvc: true,
    aluminium: false,
    image: "https://readdy.ai/api/search-image?query=vertical%20sliding%20sash%20window%20white%20upvc%20victorian%20style%20period%20home%20surrey%20traditional%20residential%20elegant%20heritage%20appearance&width=600&height=400&seq=win-sash&orientation=landscape",
    from: "£450",
    popularFor: "Victorian & Edwardian homes",
  },
  {
    id: "bay-bow",
    name: "Bay & Bow Windows",
    category: "popular",
    tagline: "Create a statement with added space",
    desc: "Bay windows project outward from the wall to create a bright alcove and extra floor space. Available as classic 3-panel bay or graceful curved bow configurations.",
    features: ["3 or 5 panel configurations", "Pole or flat ceiling options", "Optional seat board & cushion", "Any colour or finish"],
    upvc: true,
    aluminium: true,
    image: "https://readdy.ai/api/search-image?query=bay%20window%20upvc%20white%20residential%20home%20exterior%20surrey%20uk%20traditional%20three%20panel%20bay%20window%20bright%20light%20living%20room%20street%20view&width=600&height=400&seq=win-bay&orientation=landscape",
    from: "£1,100",
    popularFor: "Front rooms, living rooms",
  },
  {
    id: "flush-sash",
    name: "Flush Sash Windows",
    category: "premium",
    tagline: "Clean lines, architectural precision",
    desc: "The sash sits flush with the outer frame for a sleek, contemporary appearance. Popular in conservation areas and premium new-build developments where clean lines are essential.",
    features: ["Flush exterior face", "Conservation area approved", "Chamfered or sculptured beads", "Heritage or modern aesthetics"],
    upvc: true,
    aluminium: true,
    image: "https://readdy.ai/api/search-image?query=flush%20sash%20window%20contemporary%20slim%20frame%20white%20grey%20upvc%20modern%20uk%20home%20clean%20architectural%20lines%20minimalist%20design%20premium&width=600&height=400&seq=win-flush&orientation=landscape",
    from: "£380",
    popularFor: "Conservation areas, new builds",
  },
  {
    id: "fixed-picture",
    name: "Fixed & Picture Windows",
    category: "specialist",
    tagline: "Frame your view perfectly",
    desc: "Non-opening fixed panes maximise glazing area and create dramatic picture window effects. Ideal alongside opening casements or as standalone feature windows.",
    features: ["Maximum glass area", "No moving parts", "Custom shapes available", "Lowest u-value achievable"],
    upvc: true,
    aluminium: true,
    image: "https://readdy.ai/api/search-image?query=large%20fixed%20picture%20window%20aluminium%20frame%20modern%20uk%20home%20floor%20to%20ceiling%20glass%20view%20garden%20panoramic%20contemporary%20interior%20light&width=600&height=400&seq=win-fixed&orientation=landscape",
    from: "£220",
    popularFor: "Stairwells, feature walls, landings",
  },
];

export const upvcSpecs = [
  { label: "Profile System", value: "70mm 6-chamber Deceuninck" },
  { label: "U-Value (window)", value: "From 1.2 W/m²K" },
  { label: "WER Rating", value: "A+ (standard), A++ (upgrade)" },
  { label: "Glazing", value: "Double or Triple glazed" },
  { label: "Glass Unit Thickness", value: "28mm or 44mm" },
  { label: "Frame Colours", value: "White, Cream, Woodgrain foils, Any RAL" },
  { label: "Locking", value: "Shootbolt multi-point PAS 24" },
  { label: "Hardware", value: "Residential or SecureBy Design" },
  { label: "Warranty", value: "10-year frame, 5-year hardware" },
  { label: "Lead Time", value: "2–3 weeks" },
];

export const aluminiumSpecs = [
  { label: "Profile System", value: "Smarts Alitherm / Warmcore 47" },
  { label: "U-Value (window)", value: "From 1.0 W/m²K" },
  { label: "WER Rating", value: "A+ (standard), A++ (upgrade)" },
  { label: "Glazing", value: "Double or Triple glazed" },
  { label: "Glass Unit Thickness", value: "28mm, 36mm or 44mm" },
  { label: "Frame Colours", value: "Any RAL powder coat, dual colour" },
  { label: "Locking", value: "Multi-point espagnolette, PAS 24" },
  { label: "Hardware", value: "Stainless steel or heritage" },
  { label: "Warranty", value: "10-year frame, 10-year finish" },
  { label: "Lead Time", value: "3–4 weeks" },
];

export const energyFeatures = [
  {
    rating: "A+",
    title: "Window Energy Rating A+",
    desc: "All our windows achieve a minimum Window Energy Rating of A+ under the BFRC scheme. This is the recognised UK standard for window energy performance and is above the current Building Regulations requirement.",
    icon: "ri-leaf-line",
  },
  {
    rating: "1.2",
    ratingUnit: "W/m²K",
    title: "Outstanding U-Values",
    desc: "U-value measures how much heat escapes through a window. Our standard units achieve 1.2 W/m²K, with triple glazed upgrades reaching 0.8 W/m²K — significantly better than the 1.6 W/m²K required by Building Regs.",
    icon: "ri-temp-cold-line",
  },
  {
    rating: "Argon",
    ratingUnit: "Gas Filled",
    title: "Argon-Filled Cavities",
    desc: "Every glazing unit is filled with Argon gas, which has lower thermal conductivity than air and reduces heat transfer by up to 30% compared to air-filled units — at no extra cost.",
    icon: "ri-cloud-line",
  },
  {
    rating: "Low‑E",
    title: "Low-E Softcoat Glass",
    desc: "Our standard specification includes a low-emissivity softcoat on all glazing. This coating reflects radiant heat back into the room while still allowing solar warmth in — improving comfort and reducing heating costs.",
    icon: "ri-sun-line",
  },
];

export const windowTestimonials = [
  {
    name: "Helen & Marcus Vickers",
    location: "Caterham, Surrey",
    text: "We had 12 windows replaced throughout our 1930s semi. The flush sash uPVC windows look exactly like the original steel crittal windows but with incredible thermal performance. Our heating bills dropped noticeably the first winter.",
    avatar: "HV",
    product: "Flush Sash uPVC",
  },
  {
    name: "James Okonkwo",
    location: "Redhill, Surrey",
    text: "Chose aluminium casement windows for our extension and couldn't be happier. The slim sightlines let in so much more light and the Anthracite Grey finish looks stunning against the brick. Installation was immaculate.",
    avatar: "JO",
    product: "Aluminium Casement",
  },
  {
    name: "Patricia Alderton",
    location: "Oxted, Surrey",
    text: "Our Victorian bay windows were draughty and showing their age. Ensure Windows fitted beautiful vertical sliding sash units that have transformed the front of the house and made the sitting room so much warmer.",
    avatar: "PA",
    product: "Vertical Sliding Sash uPVC",
  },
];

export const windowFaqs = [
  {
    q: "What is the difference between uPVC and aluminium windows?",
    a: "uPVC (unplasticised polyvinyl chloride) frames are the most popular choice in the UK, offering excellent thermal performance at a lower price point. Aluminium frames are stronger and slimmer, allowing for larger glazed areas and a more contemporary look. Both materials achieve A+ energy ratings and are available in a wide range of colours. We can advise which is best for your home and budget during your free survey.",
  },
  {
    q: "How much do new windows cost in Surrey?",
    a: "Window prices vary depending on style, size, material, and the number of windows being replaced. A standard uPVC casement window starts from around £280 supply and fit. A full house of 10 windows typically costs between £3,500 and £8,000 depending on specification. We provide free, no-obligation quotes — contact us on 07852 636 300 for written pricing.",
  },
  {
    q: "Do I need planning permission to replace my windows in Surrey?",
    a: "In most cases, replacing like-for-like windows does not require planning permission and falls under permitted development rights. However, if you live in a listed building or conservation area in Surrey — such as parts of Caterham, Warlingham, or Oxted — different rules apply. We advise on planning requirements as part of your free survey and can recommend appropriate conservation-approved products.",
  },
  {
    q: "What is a Window Energy Rating (WER) and why does it matter?",
    a: "The Window Energy Rating (WER) is a UK scheme run by the British Fenestration Rating Council (BFRC) that grades windows from G (least efficient) to A++ (most efficient) based on solar heat gain, thermal transmittance, and air leakage. Current Building Regulations require a minimum of C-rated windows. Our standard windows achieve A+, which is significantly better than the legal minimum and can meaningfully reduce your energy bills.",
  },
  {
    q: "How long does window replacement take?",
    a: "Most window installations are completed in a single day. A full house replacement of 8–12 windows typically takes one to two days. Our installation teams are experienced, tidy, and ensure your home is never left open overnight.",
  },
  {
    q: "Are your windows Secured by Design certified?",
    a: "All our standard windows include PAS 24 enhanced security hardware as standard. We also offer windows certified under the police-backed Secured by Design scheme, which provides the highest level of residential security. This can be particularly important in applications for buildings insurance and for properties in areas with higher security requirements.",
  },
];
